import { deviceApi } from '@Apis/device.api';
import { StatusResponsePayload } from '@Types';
import { DataPeekResponse, SensorValidateResponse } from '@Types/peek';
import { ResampleJobRequest, ResampleJobResponse } from '@Types/sensorResample';
import { AxiosResponse } from 'axios';

type IsoDateTimeString = string;

interface TimeStampObject {
	timestamp: number;
}

export interface ResampleRequestBodyDates {
	startDateTime: IsoDateTimeString;
	endDateTime: IsoDateTimeString;
}

export interface ResampleRequestBody extends ResampleRequestBodyDates {
	sensorId: string;
}

export interface ResampleResponsePayload extends TimeStampObject {
	state: {
		desired: {
			'sync-command': {
				command: string;
				sensorId: string;
				quertStartTime: string;
				queryEndTime: string;
			};
		};
	};
	metadata: {
		desired: {
			'sync-command': {
				command: TimeStampObject;
				sensorId: TimeStampObject;
				quertStartTime: TimeStampObject;
				queryEndTime: TimeStampObject;
			};
		};
	};
	version: number;
}

const createResampleJob = async (body: ResampleJobRequest) =>
	deviceApi.post<ResampleJobResponse>('device/resample-job', body);

const resample = (body: ResampleRequestBody) =>
	deviceApi.post<{ payload: ResampleResponsePayload }>(
		'device/resample',
		body,
	);

const getStatus = <T = StatusResponsePayload>(
	shadowName?: string,
): Promise<AxiosResponse<{ payload: T }>> => {
	return deviceApi.get<{ payload: T }>('device/status', {
		params: {
			shadowName,
		},
	});
};

/**
 * @deprecated
 */
export const peekConnectionService = async (
	body: Record<string, string>,
): Promise<DataPeekResponse> => {
	const response = await deviceApi.post<DataPeekResponse>(
		'/connection/peek',
		body,
	);
	return response.data;
};

export const peekSensorService = async (
	body: Record<string, string>,
): Promise<DataPeekResponse> => {
	const response = await deviceApi.post<DataPeekResponse>(
		'/sensor/peek',
		body,
	);
	return response.data;
};

export const sensorTroubleshootService = async (
	body: Record<string, string>,
): Promise<SensorValidateResponse> => {
	const response = await deviceApi.post<SensorValidateResponse>(
		'/sensor/validate',
		body,
	);
	return response.data;
};

export { resample, getStatus, createResampleJob };

export const deviceApiService = {
	resample,
	getStatus,
	createResampleJob,
};
